<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card class="align-center d-flex flex-column">
      <CloseDialogButton :close="closeAuth" />
      <StorefrontImage class="display-none-height pt-10" size="large" />
      <LogInOptionsContent
        :closeAuth="closeAuth"
        :toAuthRoute="toAuthRoute"
        :toLogInRoute="toLogInRoute"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import LogInOptionsContent from "@/components/Auth/LogIn/Content/Options.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";

export default {
  name: "LogInOptionsDialog",
  components: {
    CloseDialogButton,
    LogInOptionsContent,
    StorefrontImage,
  },
  props: {
    closeAuth: Function,
    outsideClick: Function,
    show: Boolean,
    toAuthRoute: Function,
    toLogInRoute: Function,
  },
};
</script>
<style scoped>
@media (max-height: 768px) {
  .display-none-height {
    display: none;
  }
}
</style>
